import { render, staticRenderFns } from "./order_hs.vue?vue&type=template&id=4fbeba7f&scoped=true"
import script from "./order_hs.vue?vue&type=script&lang=js"
export * from "./order_hs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbeba7f",
  null
  
)

export default component.exports